var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16024 6.10923C6.45318 6.40208 6.45326 6.87695 6.16042 7.16989C5.0069 8.32378 4.22143 9.7938 3.90332 11.3941C3.58521 12.9943 3.74875 14.653 4.37325 16.1603C4.99775 17.6677 6.05518 18.956 7.41183 19.8624C8.76847 20.7688 10.3634 21.2526 11.995 21.2526C13.6266 21.2526 15.2215 20.7688 16.5782 19.8624C17.9348 18.956 18.9922 17.6677 19.6167 16.1603C20.2413 14.653 20.4048 12.9943 20.0867 11.3941C19.7686 9.7938 18.9831 8.32378 17.8296 7.16989C17.5367 6.87695 17.5368 6.40208 17.8298 6.10923C18.1227 5.81639 18.5976 5.81646 18.8904 6.1094C20.2537 7.47309 21.1819 9.21038 21.5579 11.1016C21.9338 12.9928 21.7406 14.9531 21.0025 16.7345C20.2645 18.5159 19.0148 20.0384 17.4115 21.1096C15.8082 22.1808 13.9232 22.7526 11.995 22.7526C10.0668 22.7526 8.18183 22.1808 6.57852 21.1096C4.97521 20.0384 3.72553 18.5159 2.98748 16.7345C2.24943 14.9531 2.05616 12.9928 2.43211 11.1016C2.80806 9.21038 3.73634 7.47309 5.09958 6.1094C5.39243 5.81646 5.8673 5.81639 6.16024 6.10923Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V12C12.75 12.4142 12.4142 12.75 12 12.75C11.5858 12.75 11.25 12.4142 11.25 12V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.79945db85f886fc2d35452089a3ec6cf.svg";
export { ForwardRef as ReactComponent };